module.exports = __webpack_public_path__ + "img/poster3-main.59be1015.png";